import { h } from 'preact';
import PropTypes from 'prop-types';
import store from '../../store';

function AppLayout(props) {
  let { children, routeHistory, title } = props;
  let hasRouteHistory = routeHistory.length > 0 && props.backUrl !== false;
  let rightAction = props.rightAction;

  if (!title) {
    title = 'IncludeCart Account';
  }

  return (
    <div className="_ic _ic__account container" data-component="AppLayout">
      <header className="bar bar-nav">
        {hasRouteHistory ? <a className="btn btn-link btn-nav pull-left" href={props.backUrl || 'javascript:window.history.go(-1);'}>
          <span className="icon icon-left-nav"></span>
          Back
        </a> : null}
        {rightAction ? <a className="btn btn-link btn-nav pull-right" href={rightAction.href}>
          {rightAction.name}
          {rightAction.icon ? <span className={'icon icon-' + rightAction.icon}></span> : null}
        </a> : null}
        <h1 className="title">{title}</h1>
      </header>

      <div className="content">
        {children}
      </div>
    </div>
  );
}

AppLayout.propTypes = {
  backUrl: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
  children: PropTypes.node.isRequired,
  routeHistory: PropTypes.array.isRequired,
  title: PropTypes.string,
  rightAction: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default store.connect(AppLayout, {
  alerts: 'alerts',
  routeHistory: 'ui.routeHistory',
});
